import { Paging } from '@shared/interfaces/pagination/paging.interface';

/**
 * Single source of truth for the initial paging.
 * Used by the user store (initial state) and the home table, so that both
 * start with a deep-equal value and no redundant request is triggered.
 */
export const DEFAULT_PAGING: Paging = { pageIndex: 0, pageSize: 10, length: 0 };
